// extracted by css-extract-rspack-plugin
export default {"vendoredPath":"_WoKYBfP_CI0w5oi","path":"covZvr8pVcIbmLn3"};